import { NgModule } from '@angular/core';
import { httpInterceptorProviders } from './index';
import { CoreRoutingModule } from './core-routing.module';
import { UnloadBaseComponent } from './components/unload-base/unload-base.component';
import { ConnectivitystatusdatePipe } from './pipes/connectivitystatusdate.pipe';
import { AutofocusDirective } from './directives/autofocus.directive';

@NgModule({
  declarations: [
     UnloadBaseComponent,
     ConnectivitystatusdatePipe,
     AutofocusDirective
  ],
  imports: [
    CoreRoutingModule
  ],
  exports:[ConnectivitystatusdatePipe,AutofocusDirective],
  providers: [httpInterceptorProviders],
  bootstrap: []
})
export class CoreModule { }
